import { useRef, useState } from 'react'
import {
  ImageType,
  SimilarMedia
} from '../../types'

import { AiFillCamera, AiFillPlaySquare } from 'react-icons/ai'
import { isVideo, isImage } from '../../helpers/mediaFileFunctions'


export type HoveOverMediaProps = {
  showHover: boolean
  photographer: string
}


type RendererProps = {
  mediaFile: ImageType | SimilarMedia
  fileId: string
  idKey: string
  classes?: string
  videoStyles?: React.CSSProperties
  onClickHandler?: Function
  showVideoControls?: boolean
  showInformationOnHover?: HoveOverMediaProps

}

export const MediaFileRenderer = ({ mediaFile, fileId, idKey = "", classes = "", videoStyles, onClickHandler, showVideoControls = false, showInformationOnHover = { showHover: false, photographer: '' } }: RendererProps) => {
  const [hoverClass, setHoverClass] = useState('mediaFileRenderer-hover-hide');
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const noop = () => { };
  const getAttributes = () => {
    let attributes: React.HTMLAttributes<any> = {}

    if (videoStyles && isVideo(mediaFile.originalFileName)) {
      attributes['style'] = videoStyles
    }
    return attributes
  }

  const getWrapperClasses = () => {
    if (showInformationOnHover.showHover) {
      return 'mediafileRenderer-hover-wrapper'
    }
    return 'mediafileRenderer-hover-wrapper'
  }

  const handlePlay = () => setIsPlaying(true)
  const handlePause = () => setIsPlaying(false)

  if (isImage(mediaFile.originalFileName)) {
    let imageUrl = mediaFile.thumbnailUrl ? mediaFile.thumbnailUrl : mediaFile.imgUrl
    return (
      <div
        key={idKey}
        className={getWrapperClasses()}
        onMouseEnter={e => {
          if (showInformationOnHover.showHover) {
            setHoverClass('mediaFileRenderer-hover-show');
          }
        }}
        onMouseLeave={e => {
          setHoverClass('mediaFileRenderer-hover-hide')
        }}>
        <img {...getAttributes()}
          src={imageUrl} alt={mediaFile.title || "image"}
          id={fileId}
          key={idKey}
          className={classes}
          onClick={() => onClickHandler ? onClickHandler() : noop()}
        />
        <div className={hoverClass}>
          <p>{mediaFile.title ? mediaFile.title : '-'}</p>
          <div className="mediafile-icon-text-wrapper">
            <div className="mediafile-photographer-icon-wrapper">
              <div style={{ marginTop: '1px' }}>
                <AiFillCamera color="black" />
              </div>
            </div>
            <p style={{ marginLeft: '4px' }}>{showInformationOnHover.photographer}</p>
          </div>
        </div>

      </div>)
  }
  
  return (
    <div
      key={idKey}
      className={getWrapperClasses()}
      onMouseEnter={e => {
        if (showInformationOnHover.showHover) {
          setHoverClass('mediaFileRenderer-hover-show');
        }
      }}
      onMouseLeave={e => {
        setHoverClass('mediaFileRenderer-hover-hide')
      }}>
      { !isPlaying ?
        <div className="videoicon">
            <AiFillPlaySquare color="white" 
            style={{position: "absolute",
              zIndex: 10,
              cursor: "pointer",
              height: "100%",
              width: "100%"}}
            onClick={() => onClickHandler ? onClickHandler() : noop()}/>
        </div> : ""
      }

      <video {...getAttributes()}
        id={fileId}
        key={idKey}
        ref={videoRef}
        className={classes}
        onClick={() => onClickHandler ? onClickHandler() : noop()}
        controls={showVideoControls}
        autoPlay={showVideoControls}
        muted={showVideoControls}
        onPlay={handlePlay}
        onPause={handlePause} >
        <source
          src={mediaFile.imgUrl}
          type={`video/${mediaFile.imgUrl.substr(mediaFile.imgUrl.lastIndexOf('.') + 1, mediaFile.imgUrl.length - 1)}`} />
        Your browser does not support the video tag.
      </video>


      <div className={hoverClass}>
        <p>{mediaFile.title ? mediaFile.title : '-'}</p>
        <div className="mediafile-icon-text-wrapper">
          <div className="mediafile-photographer-icon-wrapper">
            <div style={{ marginTop: '1px' }}>
              <AiFillCamera color="black" />
            </div>
          </div>
          <p style={{ marginLeft: '4px' }}>{showInformationOnHover.photographer}</p>
        </div>
      </div>
    </div>
  )

}